import { LucideIcon, type LucideIconName } from "../FG/LucideIcon";
import "./landing.css";

/**
 * Landing v4 — the 4-up below-the-fold reassurance strip.
 *
 * Four trust points (macros, real products, re-runnable, shipping). The grid
 * collapses 4→2→1 columns across desktop/tablet/mobile via the parent's
 * layout class.
 */
type StripItem = { icon: LucideIconName; title: string; body: string };

const ITEMS: StripItem[] = [
  {
    icon: "target",
    title: "Macros tuned to your training",
    body: "Carbs, sodium, caffeine per session."
  },
  {
    icon: "cup",
    title: "Real Fuel Goods products",
    body: "Ready to add to cart in one tap."
  },
  {
    icon: "refresh-cw",
    title: "Fuel in fresh boxes",
    body: "Buy as you go, box by box."
  },
  {
    icon: "package",
    title: "Standard 3–6 day shipping",
    body: "Expedited 2–3 days at checkout."
  }
];

export function ReassuranceStrip({ layout }: { layout: "row" | "stack" | "mobile" }) {
  const cls =
    layout === "mobile"
      ? "fgl-strip fgl-strip--mobile"
      : layout === "stack"
        ? "fgl-strip fgl-strip--stack"
        : "fgl-strip";
  return (
    <div className={cls}>
      {ITEMS.map((it) => (
        <div key={it.title} className="fgl-strip__item">
          <span className="fgl-strip__icon" aria-hidden="true">
            <LucideIcon name={it.icon} size={16} />
          </span>
          <div className="fgl-strip__text">
            <div className="fgl-strip__t">{it.title}</div>
            <div className="fgl-strip__d">{it.body}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
